function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "grad4",
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "25%",
  stopColor: "#cc31ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#19f2c8"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#grad4)",
  d: "M40 27.5c4.15 0 7.475-3.35 7.475-7.5S44.15 12.5 40 12.5a7.49 7.49 0 0 0-7.5 7.5c0 4.15 3.35 7.5 7.5 7.5zm-20 0c4.15 0 7.475-3.35 7.475-7.5S24.15 12.5 20 12.5a7.49 7.49 0 0 0-7.5 7.5c0 4.15 3.35 7.5 7.5 7.5zm0 5c-5.825 0-17.5 2.925-17.5 8.75v6.25h35v-6.25c0-5.825-11.675-8.75-17.5-8.75zm20 0c-.725 0-1.55.05-2.425.125 2.9 2.1 4.925 4.925 4.925 8.625v6.25h15v-6.25c0-5.825-11.675-8.75-17.5-8.75z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M0 0h60v60H0z"
}));

var SvgUnit = function SvgUnit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unit.e77fcbef.svg";
export { ForwardRef as ReactComponent };